import { render, staticRenderFns } from "./topUserReportForms.vue?vue&type=template&id=0f42112f&scoped=true"
import script from "./topUserReportForms.vue?vue&type=script&lang=js"
export * from "./topUserReportForms.vue?vue&type=script&lang=js"
import style0 from "./topUserReportForms.vue?vue&type=style&index=0&id=0f42112f&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f42112f",
  null
  
)

export default component.exports